<ng-container *ngIf="errors$ | async as errors">
  <div *ngIf="errors.length" class="errors">
    <button (click)="clear()" class="errors__clear" mat-mini-fab>
      <mat-icon>close</mat-icon>
    </button>
    <p *ngFor="let error of errors" class="errors__message">{{ error }}</p>
  </div>
</ng-container>
